import { LinkOpenIcon, type TypeTableColumn } from '@thefarmersfront/kitchen';

import { TextButtonCell } from '~/components/common';

import { formatDate } from '~/utils/date';

import {
  DATE_FORMAT,
  DELIVERY_AGENCY_SHIPPING_LABEL_STATUS_BADGE_COLOR,
  DELIVERY_AGENCY_TRACKING_LINKS,
} from '~/constants';

import { StatusBadge } from './deliveryAgencyTableCells';

import type { TypeDeliveryAgencyOrderDetail } from '~/types/delivery-agency.types';

type TypeDeliveryAgencyOrderDetailDeliveryInfo = TypeDeliveryAgencyOrderDetail['shippingLabelInfoOutputs'][number];

const getDeliveryAgencyOrderDeliveryInfoColumnDefs = () => {
  const columnDefs: TypeTableColumn<TypeDeliveryAgencyOrderDetailDeliveryInfo>[] = [
    {
      accessorKey: 'shippingLabelNumber',
      header: '운송장 번호',
      size: 245,
    },
    {
      accessorKey: 'shippingLabelStatus',
      header: '운송장 상태',
      size: 100,
      cell: ({ row }) => {
        const value = row.original.shippingLabelStatus;
        if (!value) return null;

        return (
          <StatusBadge value={value} colors={DELIVERY_AGENCY_SHIPPING_LABEL_STATUS_BADGE_COLOR} dashIfNoLabel={false} />
        );
      },
    },
    {
      accessorKey: 'statusUpdatedAt',
      header: '상태 마지막 업데이트 일시',
      size: 170,
      cell: ({ row }) => formatDate(row.original.statusUpdatedAt, DATE_FORMAT.DATE_TIME) ?? '-',
    },
    {
      id: 'deliveryType',
      accessorFn: (row) => row.deliveryType?.description,
      header: '배송 유형',
      size: 80,
    },
    {
      id: 'courierCode',
      accessorFn: (row) => row.courierCode?.description,
      header: '배송사',
      size: 88,
    },
    {
      id: 'trackingLink',
      accessorKey: 'shippingLabelNumber',
      header: '',
      minSize: 298,
      cell: ({ getValue, row }) => {
        const courierCode = row.original.courierCode.code as keyof typeof DELIVERY_AGENCY_TRACKING_LINKS | undefined;
        const invoiceNumber = row.original.shippingLabelNumber;
        const url =
          courierCode && invoiceNumber ? DELIVERY_AGENCY_TRACKING_LINKS[courierCode] + invoiceNumber : undefined;

        return (
          <TextButtonCell
            value={getValue()}
            variant="normal"
            target="_blank"
            href={url}
            rightIcon={<LinkOpenIcon size={16} color="#672091" />}
          >
            배송조회
          </TextButtonCell>
        );
      },
      meta: { flex: true },
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyOrderDeliveryInfoColumnDefs;
